type ObjectType = Record<string, any>;

const isGetter = (x: ObjectType, name: string) =>
  (Object.getOwnPropertyDescriptor(x, name) || {}).get;

const isFunction = (x, name) => typeof x[name] === 'function';

const deepFunctions = x =>
  x &&
  x !== Object.prototype &&
  Object.getOwnPropertyNames(x)
    .filter(name => isGetter(x, name) || isFunction(x, name))
    .concat(deepFunctions(Object.getPrototypeOf(x)) || []);

const distinctDeepFunctions = (x: ObjectType) =>
  Array.from(new Set<string>(deepFunctions(x)));

/* __OR__
simple:
Object.getOwnPropertyNames(EntityBaseApiService.prototype)

with inheritance:
Object.getOwnPropertyNames(Object.getPrototypeOf(cat))
*/

export default function getMethods(obj: ObjectType) {
  return distinctDeepFunctions(obj).filter(
    name => name !== 'constructor' && !~name.indexOf('__')
  );
}
